var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.accountIds),expression:"accountIds"}],staticClass:"awsui-textarea",attrs:{"type":"text","rows":"3"},domProps:{"value":(_vm.accountIds)},on:{"input":function($event){if($event.target.composing)return;_vm.accountIds=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }